import React, { useContext } from 'react';
import c from 'classnames';
import { CommentEditorContext } from '../../../CommentEditor/context';
import EditorDropzone from '@wix/da-editor-tiptap/pkg/components/lego/EditorDropzone';
import s from './CommentBoxContentWrapper.scss';
/**
 * Standard styling for the content of our comment box.
 * Also adds the global editor class we need for themeing inside of DaEditor
 */ const CommentBoxContentWrapper = ({ children, className })=>{
    const { isExpanded } = useContext(CommentEditorContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['commentbox-content'], 'da-editor-comment', isExpanded && s['expanded'], className)
    }, /*#__PURE__*/ React.createElement(EditorDropzone, null, children));
};
CommentBoxContentWrapper.displayName = 'CommentBoxContentWrapper';
export default CommentBoxContentWrapper;

//# sourceMappingURL=CommentBoxContentWrapper.js.map